import * as Yup from 'yup';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
// form
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
// @mui
import { Link, Stack, IconButton, InputAdornment } from '@mui/material';
import { LoadingButton } from '@mui/lab';
// components
import Iconify from '../../../components/Iconify';
import { FormProvider, RHFTextField, RHFCheckbox } from '../../../components/hook-form';

// ServerURL
import url from 'src/serverURL.js';
// ----------------------------------------------------------------------

export default function LoginForm() {
  const navigate = useNavigate();

  const [showPassword, setShowPassword] = useState(false);
  const [email,setEmail]=useState("")
  const [password,setPassword]=useState("")

  const LoginSchema = Yup.object().shape({
    name: Yup.string(),
    password: Yup.string().required('Password is required'),
  });

  const defaultValues = {
    name: '',
    password: '',
    remember: true,
  };

  const methods = useForm({
    resolver: yupResolver(LoginSchema),
    defaultValues,
  });

  const {
    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  const onSubmit = async (e) => {
  
    var data={
      name:e.name,
      password:e.password
     }
     fetch(url + 'inventry/user/Login', {
       method: 'POST',
       headers: {
         'Content-Type': 'application/json'
       },
       body:JSON.stringify(data)
     }).then((res) => { return res.json() }).then(res => {
      console.log(res)
       if(res.id== "Invalid Credientails"){
         window.alert("Invalid Credientails!!")
       }else{
        
        localStorage.setItem('admin','true')
        localStorage.setItem('name',e.name)
        localStorage.setItem('id',res.id)
        localStorage.setItem('role',res.role)
        localStorage.setItem('actions',JSON.stringify(res.actions))
        navigate('/dashboard/topSales', { replace: true });
      
       }
  })
  
  };

  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
      <Stack spacing={3}>
        <RHFTextField name="name" label="User Name" />

        <RHFTextField
          name="password"
          label="Password"
          
          type={showPassword ? 'text' : 'password'}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                  <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Stack>

      <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ my: 2 }}>
        
      </Stack>

      <LoadingButton fullWidth size="large" type="submit" variant="contained" loading={isSubmitting}>
        Login
      </LoadingButton>
    </FormProvider>
  );
}
